import { createStore, combineReducers } from 'redux';
import { emos } from "./components/EmoSlider/EmoSlider.reducer";
import { animation } from "./components/FacePlot/FacePlot.reducer";

export default createStore(combineReducers({
    emos,
    animation
}))
